<template>
    <div>
        <b-dropdown
                variant="link"
                no-caret
                toggle-class="px-0"
        >
            <template v-slot:button-content>
                <div class="flex py-0.5 pb-1">
                    <img v-if="lang === 'ru'" src="/images/russia.png" alt="russian_flag" class="h-6 w-6">
                    <img v-if="lang === 'en'" src="/images/united-states-of-america-flag-png-large.png" alt="usa_flag" class="h-4 w-6 mt-1">
                    <img v-if="lang === 'uz'" src="/images/uzb-flag.png" alt="russian_flag" class="h-4 w-6 mt-1">
                    <span class="d-none d-sm-block rounded ml-1">{{ langName }}</span>
                    <span><img src="/images/DownArrow.png" class="ml-1" alt="down_arrow"></span>
                </div>

            </template>

            <b-dropdown-item v-bind:active="lang === 'uz'" @click="goWithLang('uz')">
                <span>o'zb</span>
            </b-dropdown-item>

            <b-dropdown-item v-bind:active="lang === 'ru'" @click="goWithLang('ru')">
                <span>рус</span>
            </b-dropdown-item>

            <b-dropdown-item v-bind:active="lang === 'en'" @click="goWithLang('en')">
                <span>eng</span>
            </b-dropdown-item>
        </b-dropdown>
    </div>

</template>

<script>
    export default {
        name: "LanguageSwitcher",
        data() {
            return {
                lang: this.$i18n.locale,
            }
        },
        computed: {
            langName() {
                switch (this.lang) {
                    case 'ru':
                        return "рус"
                    case 'en':
                        return "eng"
                    case 'uz':
                    default:
                        return "uz"
                }
            },

        },
        methods: {
            goWithLang(lang) {
                this.setCookie('lang', lang, 7)
                this.$router.push('/' + lang + '/' + this.$route.path.slice(4))
            },
            setCookie(name, value, days) {
                let expires = ''

                if (days) {
                    const date = new Date();
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                    expires = "; expires=" + date.toUTCString();
                }

                let domain = ''

                if (process.env.NODE_ENV === 'production') {
                    domain = 'domain=.boshqar.com'
                }

                document.cookie = name + "=" + (value || "") + expires + `; path=/; ${domain}`;
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.lang = this.$i18n.locale
            }
        }
    }

</script>

<style scoped>

</style>
